<template>
  <div id="layout_168">
    <div style="min-height: 100vh">
      <transition mode="out-in" name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "layout",
};
</script>

<style lang="less" scoped>
#layout_168 {
  padding-top: 72px;
}
@media (max-width: 767px) {
  #layout_168 {
    padding-top: 60px;
  }
}
</style>
